<template >
    <Navigation
        class="d-flex"
        :navigationItemList="documents"
        :data="data"
        @selectNavigationItem="loadDocument"
    />
</template>

<script>
    import { EventBus } from '@/event-bus';

    import Navigation from '@/layout/alternative/layout/components/Navigation.vue';

    export default {
        name: "DocumentationBody",
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        components:{
            Navigation,
        },
        computed:{
            documents() {
                return this.$props.data ?this.$props.data.documents : {};
            }
        },
        methods: {
            loadDocument(index) {
                let localData = _.cloneDeep(this.data);
                localData.documents.filter(el => el.active).forEach(el => el.active = false);
                localData.documents[index].active = true;
                let activeDocument = localData.documents.find(document => document.active === true);
                EventBus.$emit('updateSidebar', localData, false);
                EventBus.$emit('updateDocumentSource', activeDocument.link);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/documentation/DocumentationBody.vue